
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { isGoodsValid } from '@/api/industryMall'
import { decimalPrecision } from '@/utils/util'
import customRadio from '@/views/industryMall/goods/components/customRadio.vue'
import priceFun from '@/views/industryMall/shop/template/priceFun.vue'
import { batchHandleGoods } from '@/api/ccx'

@Component({
  components: {
    priceFun,
    customRadio
  }
})
export default class editGoodsCards extends Vue {
  decimalPrecision = decimalPrecision

  @Getter companyId!: string
  @Prop({ default: () => {} }) data!: any
  showPopup = false
  price = 0
  scribingPrice = 0
  sftpUrl = ''

  @Watch('data')
  dataChange(val) {
    console.log('dataChange**************', val)
  }

  mounted () {
    this.sftpUrl = this.$store.state.user.sftpUrl
  }

  upShelves () {
    batchHandleGoods({
      storeId: this.companyId,
      goodsStatus: 1,
      supplierGoodsList: [{
        supplierGoodsId: this.data.supplierGoodsId,
        price: this.data.price || this.data.suggestedPrice,
        goodsId: this.data.goodsId
      }]
    }).then(() => {
      this.$toast('上架成功')
      this.$emit('reloadList')
    })
  }

  downShelves () {
    batchHandleGoods({
      storeId: this.companyId,
      goodsStatus: 2,
      supplierGoodsList: [{
        supplierGoodsId: this.data.supplierGoodsId,
        price: this.data.price || this.data.suggestedPrice,
        goodsId: this.data.goodsId
      }]
    }).then(() => {
      this.$toast('下架成功')
      this.$emit('reloadList')
    })
  }

  editPrice () {
    this.showPopup = true
    this.price = this.data.price || this.data.suggestedPrice
    this.scribingPrice = this.data.scribingPrice || undefined
  }

  onChangePrice () {
    console.log('onChangePrice', this.price)
    return new Promise((resolve) => {
      if (!this.price || this.price < this.data.costPrice) {
        this.$toast('售价必须高于或等于进价！')
        resolve(false)
      }
      resolve(true)
    })
  }

  onChangeScribingPrice () {
    return new Promise((resolve) => {
      if (!this.scribingPrice) {
        this.scribingPrice = undefined
        resolve(true)
      } else if (this.scribingPrice <= this.price) {
        this.$toast('划线价必须高于售价！')
        resolve(false)
      }
      resolve(true)
    })
  }

  onCancel () {
    this.showPopup = false
  }

  async onSave () {
    const isCheckPrice = await this.onChangePrice()
    if (!isCheckPrice) return isCheckPrice
    const isCheckScribingPrice = await this.onChangeScribingPrice()
    if (!isCheckScribingPrice) return isCheckScribingPrice

    batchHandleGoods({
      storeId: this.companyId,
      goodsStatus: this.data.goodsStatus === 1 ? 1 : 2,
      supplierGoodsList: [{
        supplierGoodsId: this.data.supplierGoodsId,
        price: this.price,
        scribingPrice: this.scribingPrice,
        goodsId: this.data.goodsId
      }]
    }).then(() => {
      this.$toast('修改成功')
      this.data.price = this.price
      this.data.scribingPrice = this.scribingPrice
      this.showPopup = false
      // this.$emit('reloadList')
    })
  }

  // 校验商品是否已失效/下架
  isGoodsValid() {
    const params = {
      shopId: this.data.storeId,
      goodsId: this.data.goodsId
    }
    return isGoodsValid(params)
      .then((res) => {
        if (res.data.isValid) {
          return true
        } else {
          this.$dialog
            .alert({
              message: '商品过期不存在'
            })
            .then(() => {
              this.$emit('reloadList')
            })
          return false
        }
      })
      .catch(() => {
        return false
      })
  }

  changeVal (val: number) {
    this.$emit('changeVal', val)
  }

  blurVal (packageIndex: number) {
    const packageId = this.data.goodsPackageList[packageIndex].packageId
    this.$emit('blurVal', packageId)
  }

  keyboardConfirm (price: string, packageIndex: number) {
    this.changeVal(Number(price))
    this.blurVal(packageIndex)
  }
}
